import { render, staticRenderFns } from "./ClientEditor.vue?vue&type=template&id=1452d983&scoped=true&"
import script from "./ClientEditor.vue?vue&type=script&lang=js&"
export * from "./ClientEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452d983",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1452d983')) {
      api.createRecord('1452d983', component.options)
    } else {
      api.reload('1452d983', component.options)
    }
    module.hot.accept("./ClientEditor.vue?vue&type=template&id=1452d983&scoped=true&", function () {
      api.rerender('1452d983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ClientEditor.vue"
export default component.exports